import ConstructorSection from '@/models/list/ConstructorSection';
import { SECTION_TYPES } from './constants';

export const toInternalValue = (titleSection, genericSections) => ({
  sections: [
    {
      id: titleSection.id,
      type: SECTION_TYPES.title,
      data: {
        title: titleSection.title,
        description: titleSection.description,
        shadow_level: titleSection.shadow_level,
      },
      image: titleSection.background ? titleSection.background : undefined,
    },
    ...genericSections.map((section) => ({
      id: section.value.id,
      type: section.value.type,
      data: {
        title: section.value.title,
        description: section.value.description,
      },
      cards: section.cards.map((card) => ({
        id: card.id,
        type: card.type,
        data: {
          title: card.title,
          description: card.description,
          iconpath: card.avatar && card.avatar.isIcon ? card.avatar.value : undefined,
          url: card.url || undefined,
        },
        image: card.avatar && !card.avatar.isIcon ? card.avatar.value : undefined,
        document: card.document,
      })),
    })),
  ],
});

export const toRepresentationValue = (data) => {
  const sections = [...data];

  const titleSection = sections.shift();
  return {
    titleSection: {
      ...titleSection.data,
      background: titleSection.image,
      id: titleSection.id,
    },
    genericSections: sections.map((i) => {
      const cards = i.cards && i.cards.map((card) => ({
        id: card.id,
        type: card.type,
        title: card.data.title,
        description: card.data.description,
        avatar: card.image || card.data.iconpath ? {
          value: card.image || card.data.iconpath,
          isIcon: !card.image,
        } : null,
        url: card.data.url,
        document: card.document,
      }));
      let cardsType;
      if (cards && cards.length) {
        const [primaryCard] = cards;
        cardsType = primaryCard.type;
      }
      return new ConstructorSection({
        value: {
          id: i.id,
          type: i.type,
          cards,
          title: i.data.title,
          description: i.data.description,
        },
        cardsType,
      });
    }),
  };
};
